import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Moon = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      stroke="none"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M6 0C2.5.9 0 4.1 0 7.9 0 12.4 3.6 16 8.1 16c3.8 0 6.9-2.5 7.9-6C9.9 11.7 4.3 6.1 6 0z" />
    </svg>
  );
};

Moon.displayName = 'Moon';
